<script setup>
  import { StrapiBlocks } from 'vue-strapi-blocks-renderer'

  defineProps({
    item: {
      type: Object,
      default: () => ({})
    }
  })

  const config = useRuntimeConfig()
  const consentStore = useConsentStore()
  const { t } = useI18n()
  const marketingAllowed = computed(() => consentStore.marketingAllowed)
</script>

<template>
  <div>
    <StrapiBlocks v-if="item.__component === 'shared.rich-text' && item.content" :content="item.content" />
    <!-- eslint-disable-next-line vue/no-v-html -->
    <div v-if="item.__component === 'shared.ck-editor'" v-html="item.CKE" />
    <!-- Support for direct CKE property (legacy format) -->
    <!-- eslint-disable-next-line vue/no-v-html -->
    <div
      v-else-if="item.CKE"
      class="prose lg:prose-xl max-w-none mb-12 prose-a:text-sky-600 prose-a:hover:text-sky-500"
      v-html="item.CKE"
    />
    <div v-if="item.__component === 'shared.media' && item?.file?.url" class="flex justify-center">
      <img :src="`${config.public.strapi}${item.file.url}`" />
    </div>
    <NuxtLink
      v-if="item.__component === 'shared.cta' && item.url"
      :to="item.url"
      class="not-prose block py-2 px-4 text-center bg-sky-800 hover:bg-sky-700 text-white rounded"
    >
      {{ item.title }}
    </NuxtLink>
    <ClientOnly>
      <div v-if="item.__component === 'shared.youtube'" class="flex justify-center">
        <div class="w-full lg:w-3/5">
          <div v-if="marketingAllowed" class="relative pb-[56.25%]">
            <iframe
              class="absolute top-0 left-0 w-full h-full rounded-lg"
              :src="`https://www.youtube.com/embed/${item.youtube_id}`"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerpolicy="strict-origin-when-cross-origin"
              allowfullscreen
            ></iframe>
          </div>
          <div
            v-else
            class="relative pb-[56.25%] bg-slate-100 border border-slate-200 rounded-lg flex items-center justify-center"
          >
            <div class="absolute inset-0 flex items-center justify-center px-4 text-center">
              <div class="space-y-3">
                <p class="text-sm text-slate-700">{{ t('consent.videoPlaceholder') }}</p>
                <button
                  class="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-sky-700 text-white text-sm font-semibold hover:bg-sky-800 transition-colors"
                  type="button"
                  @click="consentStore.openPreferences()"
                >
                  <font-awesome :icon="['fas', 'sliders-h']" class="text-xs" />
                  {{ t('consent.manageLink') }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else-if="item.youtube_id" class="my-4 flex justify-center">
        <div class="mb-4 w-full lg:w-3/5">
          <div v-if="marketingAllowed" class="relative pb-[56.25%]">
            <iframe
              class="absolute top-0 left-0 w-full h-full rounded-lg"
              :src="`https://www.youtube.com/embed/${item.youtube_id}`"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerpolicy="strict-origin-when-cross-origin"
              allowfullscreen
            ></iframe>
          </div>
          <div
            v-else
            class="relative pb-[56.25%] bg-slate-100 border border-slate-200 rounded-lg flex items-center justify-center"
          >
            <div class="absolute inset-0 flex items-center justify-center px-4 text-center">
              <div class="space-y-3">
                <p class="text-sm text-slate-700">{{ t('consent.videoPlaceholder') }}</p>
                <button
                  class="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-sky-700 text-white text-sm font-semibold hover:bg-sky-800 transition-colors"
                  type="button"
                  @click="consentStore.openPreferences()"
                >
                  <font-awesome :icon="['fas', 'sliders-h']" class="text-xs" />
                  {{ t('consent.manageLink') }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ClientOnly>
  </div>
</template>
